import { render, staticRenderFns } from "./UserHome.vue?vue&type=template&id=64827e22&scoped=true"
import script from "./UserHome.vue?vue&type=script&lang=js"
export * from "./UserHome.vue?vue&type=script&lang=js"
import style0 from "./UserHome.vue?vue&type=style&index=0&id=64827e22&prod&lang=scss&scoped=true"
import style1 from "./UserHome.vue?vue&type=style&index=1&id=64827e22&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64827e22",
  null
  
)

export default component.exports